import React from 'react';

const Header: React.FC = () => {
    return (
        <header className="bg-white shadow-md w-full p-4">
            <div className="container mx-auto flex flex-col justify-center items-center text-center">
                <img
                    alt="Company Logo"
                    className="w-120 h-auto mb-2 p-4 md:px-0"
                    src="/images/impulse_1000.png"
                />
                <p className="text-lg font-semibold text-gray-700">Herzlich Willkommen zur Anmeldeseite für die Limbach Jahresauftaktveranstaltung 2026!</p>
                <p className="text-gray-600 mt-2">Bitte melden Sie sich bis zum 06.12.2025 an.</p>
                <p className="text-gray-600 mt-2">Wenn Sie nach dem 06.12.2025 noch Änderungen bezüglich Ihrer angegebenen Daten
vornehmen möchten, wenden Sie sich bitte per Mail an <a className="text-magenta hover:underline" href="mailto:support@limbach-jahresauftakt.de">support@limbach-jahresauftakt.de</a>.</p>
            </div>
        </header>
    );
};

export default Header;
